// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container fixed bottom right */
.chatbot-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1100;
  display: none;
}

.main-panel:has(.main-content .ai-page) + .chatbot-container {
  display: block !important;
}

/* Floating circular button */
.chatbot-btn {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #007bff;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease-in-out;
  outline: none;
}

.chatbot-btn:hover {
  transform: scale(1.1);
}

/* Chat icon inside button */
.chat-icon {
  width: 45px;
  height: auto;
  filter: brightness(0) invert(1); /* white icon */
}

/* Chat window popup */
.chat-window {
  width: 300px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  animation: fadeIn 0.3s ease;
  position: absolute; /* FIX: position relative to container */
  bottom: 90px; /* show above button */
  right: 0; /* align to right edge */
}
.chat-window :after {
  content: "";
  position: absolute;
  bottom: -10px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
}

/* Header with close */
.chat-header {
  display: flex;
  justify-content: flex-end;
  padding: 6px 10px;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #888;
}

.close-btn:hover {
  color: #333;
}

/* Body with message */
.chat-body {
  padding: 0 15px 20px;
  text-align: center;
}

.explore-text {
  background: #007bff;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  display: inline-block;
}

.explore-text:hover {
  background: #0056b3;
}

/* End  HP */`, "",{"version":3,"sources":["webpack://./src/app/layouts/full/full-layout.component.scss"],"names":[],"mappings":"AACA,sCAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;AAAF;;AAGA;EAA+D,yBAAA;AAC/D;;AAEA,6BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,aAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA,4BAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,+BAAA,EAAA,eAAA;AACF;;AAEA,sBAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,2BAAA;EACA,kBAAA,EAAA,wCAAA;EACA,YAAA,EAAA,sBAAA;EACA,QAAA,EAAA,wBAAA;AACF;AACI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,2BAAA;AACR;;AAKA,sBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAFF;;AAIA;EACE,WAAA;AADF;;AAIA,sBAAA;AACA;EACE,oBAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AADF;;AAGA;EACE,mBAAA;AAAF;;AAGA,YAAA","sourcesContent":["\n/* Main container fixed bottom right */\n.chatbot-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1100;\n  display: none;\n} \n \n.main-panel:has(.main-content .ai-page) + .chatbot-container { display: block !important;}\n\n\n/* Floating circular button */\n.chatbot-btn {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  background: #007bff;\n  border: none;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease-in-out;\n  outline: none;\n}\n\n.chatbot-btn:hover {\n  transform: scale(1.1);\n}\n\n/* Chat icon inside button */\n.chat-icon {\n  width: 45px;\n  height: auto;\n  filter: brightness(0) invert(1); /* white icon */\n}\n\n/* Chat window popup */\n.chat-window {\n  width: 300px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 6px 20px rgba(0,0,0,0.25);\n  animation: fadeIn 0.3s ease;\n  position: absolute;   /* FIX: position relative to container */\n  bottom: 90px;         /* show above button */\n  right: 0;             /* align to right edge */\n\n    :after {\n        content:\"\";\n        position: absolute;\n        bottom: -10px;\n        right:20px;\n        width: 0;\n        height: 0;\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-top: 10px solid #fff;\n    }\n\n}\n\n\n/* Header with close */\n.chat-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 10px;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #888;\n}\n.close-btn:hover {\n  color: #333;\n}\n\n/* Body with message */\n.chat-body {\n  padding: 0 15px 20px;\n  text-align: center;\n}\n\n.explore-text {\n  background: #007bff;\n  color: #fff;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 15px;\n  cursor: pointer;\n  display: inline-block;\n}\n.explore-text:hover {\n  background: #0056b3;\n}\n\n/* End  HP */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
